import {NavLink, useNavigate, useParams} from "react-router-dom";
import "./StyleHintCard.css";
import ButtonBack from "../../../components/Buttons/buttonBack/ButtonBack";
import ButtonHint from "../../../components/Buttons/buttonHint/ButtonHint";
import React, {useEffect, useState} from "react";
import {FetchElements, GetCookie, updateRefreshToken, useButtonLock} from "../../../utils/js/request";
import {
    DELETE_DATA_IN_LocalStorage,
    GET_ROLE,
    GET_SELECTED_SHOP_ID,
    REQUEST,
    UPDATE_ATTACH_USER_ID,
} from "../../../utils/js/Const";
import ButtonUpScroll from "../../../components/Buttons/buttonUpScroll/ButtonUpScroll";
import CustomAlert from "../../../components/CustomAlert/CustomAlert";

function HintCard({ ...data }) {

    const { id } = useParams();
    let navigate = useNavigate();
    let selectedId = GET_SELECTED_SHOP_ID();
    let role = GET_ROLE();
    let key = 1;

    const [card, setCard] = useState([]);
    const [accessToken, setAccessToken] = useState(GetCookie("access_token"));
    const [attachUsers, setAttachUsers] = useState([]);
    const [selectedUsers, setSelectedUsers] = useState({});
    const [attachUser, setAttachUser] = useState("")

    const [isOpenAlert, setIsOpenAlert] = useState(false);
    const [alertMessage, setAlertMessage] = useState('');
    const [alertTitle, setAlertTitle] = useState('');
    const [alertStatusCod, setAlertStatusCod] = useState('')
    const [alertLoadingGif, setAlertLoadingGif] = useState('');

    //Универсальный блокиратор отправки повторных запросов
    const { isDisabled, lockButton, unlockButton } = useButtonLock();

    const handleOpenAlert = (title, message, statusCod, LaodingGif) => {
        setAlertTitle(title);
        setAlertMessage(message);
        setAlertStatusCod(statusCod);
        setIsOpenAlert(true);
        setAlertLoadingGif(LaodingGif);
    };

    const handleCloseAlert = () => {
        setIsOpenAlert(false);
    };

    useEffect(() => {
        const fetchData = async () => {
            if (!accessToken) {
                const newToken = await updateRefreshToken(setAccessToken, null, () => { navigate("/") });
                if (newToken) {
                    loadData();
                }
            } else {
                loadData();
            }
        };
        fetchData();
    }, [accessToken, id,selectedUsers]);

    const loadData = () => {
        FetchElements(`${REQUEST}/api/v1/groups_tasks/${id}?shop_id=${selectedId}`, "GET", setCard);
       /* _get_role(role);*/
    };

/*    function _get_role (role){
        if (role !== "Обычный") {
            return (FetchElements(`${REQUEST}/api/v1/employees/${selectedId}`, "GET", setAttachUsers))
        }
    }*/

/*    function handelAttachUser (e, cardId) {
        const AttachUseId = e.target.value;
        setSelectedUsers(prevState => ({
            ...prevState,
            [cardId]: AttachUseId
        }));
        setAttachUser(AttachUseId)
        UPDATE_ATTACH_USER_ID (AttachUseId);

    }*/

/*    function select_attachUser (_attachUser , cardId) {
        let localAttachUser  = selectedUsers[cardId] || 0;

        return (
            <select value={localAttachUser } id="searchGroup" onChange={(e) => handelAttachUser (e, cardId)}>
                <option value="0" disabled hidden>Выберите сотрудника</option>
                {_attachUser.map((attachUser ) => (
                    <option value={attachUser.id} key={attachUser.id}>{attachUser.full_name}</option>
                ))}
            </select>
        );
    }*/

    //////ЗАКРЕП ЗАДАЧИ ЗА СОТРУДНИКОМ////////
    async function employeUser(task){

        if (isDisabled === true) {
            handleOpenAlert("Уведомление", "Дождитесь предыдущей операции", "");
            return;
        }

        lockButton();

        handleOpenAlert('Уведомление', `Идет загрузка`, ``, "loader");

        let response =  await fetch(`${REQUEST}/api/v1/tasks/${task}/attach_user/${attachUser}`,
            {method:"PATCH",
                headers: {
                    'Accept': 'application/json',
                    "access-token": `${accessToken}`,
                },
            });
        const data = await response.json();

        if(response.ok){
            unlockButton();
            loadData();
            setAttachUser("");
            DELETE_DATA_IN_LocalStorage("ATTACH_USER_ID");
            handleOpenAlert('Уведомление', `${data.message ||"Успех!"}, ${response.status || ""}`);
        }else{
            setAttachUser("");
            DELETE_DATA_IN_LocalStorage("ATTACH_USER_ID");
            unlockButton();
            handleOpenAlert('Ошибка', `${data.message ||"При закрепление подсказки за сотрудником произошла ошибка, проверьте указан ли сотрудник!"}, ${response.status || ""}`);
        }

    }

    function returnClassColorHintCard(data) {

        if (data?.close?.cause_id === 2 && data?.is_closed === true) {
            return "is_closed_in_not_actual_remains";
        }

        if (data?.is_closed === true) {
            return "is_closed";
        }

        if (data?.is_system_closed === true || data?.is_confirm === true) {
            return "is_system_closed";
        }

        return "";
    }

    return (
        <>
            <ButtonBack />
            <CustomAlert
                title={alertTitle}
                message={alertMessage}
                statusCod={alertStatusCod}
                isOpenAlert={isOpenAlert}
                onClose={handleCloseAlert}
                classAlertLoading={alertLoadingGif}
            />
            {
                card?.map((data) => {
                    return (
                        <div className={`max--width--control hint__card ${returnClassColorHintCard(data)}`}
                             key={data.id}>
                            <div className="hint__card__title_wrapper">
                                <div className="hint__card__title">
                                    <span>{data.name}</span>
                                    <div className={`${data.is_closed || data.is_confirm ? "HintPin" : ""}`}></div>
                                </div>
                                <div className="pin-employe"
                                     style={{display: (data.user && data.user.full_name ? '' : 'none')}}>
                                        Закреплено за: {data.user ? data.user.full_name : 'Не назначен'}
                                </div>
                            </div>
                            <div className="hint__card__wrapper">
                                <img className="hint__card__img" src={data.attachment} alt="иконка товара" loading="lazy"/>
                                <div className="hint__card__list--wrapper">
                                    <div className="hint__card__list">
                                        {data.values?.map((item) => {
                                            return (<p key={key += 1}>{item.name}: <span>{item.value}</span></p>)
                                        })}
                                        <p>Статус закрытия: <span>{data.is_system_closed ? "Закрыта автоматически" : data.is_closed ? "Закрыта в ручную" :"Не закрыта"}</span></p>
                                    </div>
                                    <div>
{/*                                        <div className="wrapper_pin-employe" id="wrapper_pin-employe--desctop"
                                             style={{display: ((role === "Обычный" || role === "Руководитель" || role === "Учебный центр"? 'none' : ''))}}>
                                            <div className="search--container__but">
                                                <label className="select" id="select_pin-employe">
                                                    {select_attachUser(attachUsers, data.id)}
                                                </label>
                                            </div>
                                            <ButtonHint className={"wrapper_pin-employe--button"} text={"закрепить"}
                                                        funck={() => {
                                                            employeUser(`${data.id}`)
                                                        }}
                                            />
                                        </div>*/}
                                        {data.is_1c ? (
                                            <NavLink
                                                className="hint--flex max--width--control"
                                                to={{pathname: `/HintSeries/${data.id}`}}
                                                state={{data: data.name, task_id: data.id, type_task_id: data.type_task_id}}>
                                                <ButtonHint
                                                    className={data.is_closed ? "hint__button button--hint__green" : "hint__button button--hint__red"}
                                                    id={"hint__button__decktop"}
                                                    text={"перейти к подсказке"}
                                                    isDisabled={isDisabled}
                                                />
                                            </NavLink>
                                        ) : (
                                            <NavLink
                                                className="hint--flex max--width--control"
                                                to={{pathname: `/HintContainer/${data.id}`}}
                                                state={{data: data.name, task_id: data.id, type_task_id: data.type_task_id}}>
                                                <ButtonHint
                                                    className={data.is_closed ? "hint__button button--hint__green" : "hint__button button--hint__red"}
                                                    id={"hint__button__decktop"}
                                                    text={"перейти к подсказке"}
                                                    isDisabled={isDisabled}
                                                />
                                            </NavLink>
                                        )}
                                    </div>
                                </div>
                            </div>
{/*                            <div className="wrapper_pin-employe" id="wrapper_pin-employe--mobile"
                                 style={{display: ((role === "Обычный" || role === "Руководитель" || role === "Учебный центр"? 'none' : ''? 'none' : ''))}}>
                                <div className="search--container__but">
                                    <label className="select" id="select_pin-employe--mobile">
                                        {select_attachUser(attachUsers, data.id)}
                                    </label>
                                </div>
                                <ButtonHint className={"wrapper_pin-employe--button wrapper_pin-employe--button--mobile"} text={"закрепить"} funck={() => {
                                    employeUser(`${data.id}`)
                                }}/>
                            </div>*/}
                            {data.is_1c ? (
                                <NavLink
                                    to={{pathname: `/HintSeries/${data.id}`}}
                                    state={{data: `${data.name}`, task_id: `${data.id}`, type_task_id:`${data.type_task_id}`}}>
                                    <ButtonHint
                                        className={`hint__button ${data.is_closed ? "hint__button button--hint__green" : "hint__button button--hint__red"}`}
                                        id={"hint__button__mobile"}
                                        text={"перейти к подсказке"}
                                        isDisabled={isDisabled}
                                    />
                                </NavLink>
                            ):(
                                <NavLink
                                    to={{pathname: `/HintContainer/${data.id}`}}
                                    state={{data: `${data.name}`, task_id: `${data.id}`, type_task_id:`${data.type_task_id}`}}>
                                    <ButtonHint
                                        className={`hint__button ${data.is_closed ? "hint__button button--hint__green" : "hint__button button--hint__red"}`}
                                        id={"hint__button__mobile"}
                                        text={"перейти к подсказке"}
                                        isDisabled={isDisabled}
                                    />
                                </NavLink>
                            )}
                        </div>
                    )
                })
            }
            {
                card.length >= 3 ? <ButtonUpScroll/> : ""
            }

        </>
    )
}

export default HintCard;